import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Pricing page components

import {
  AssuredWorkload,
  BarChart,
  CloudSync,
  ContentPasteGo,
  CurrencyExchange,
  DoneAll,
  FolderCopy,
  ShowChart,
  Topic,
} from "@mui/icons-material";
import BenefitCard from "components/CustomCards/BenefitCard";

function Faq() {
  return (
    <SoftBox mt={16}>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={12}>
          <SoftTypography variant="h2" align="center" fontWeight="bold" gutterBottom>
            Οφέλη Ηλεκτρονικής Tιμολόγησης
          </SoftTypography>
          <SoftBox mb={2}>
            <SoftTypography variant="body2" align="center" color="text">
              Με την ηλεκτρονική έκδοση των παραστατικών χονδρικής αλλά και λιανικής, απολαμβάνεται
              μειωμένο κόστος και μοναδικά οφέλη για την επιχείρησή σας.
            </SoftTypography>
          </SoftBox>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <BenefitCard
              title="Έλεγχος εγκυρότητας"
              description="Το εκδοθέν παραστατικό ελέγχεται άμεσα για την εγκυρότητά του, σύμφωνα με τις ισχύουσες φορολογικές διατάξεις."
              padding="18%"
              icon={<DoneAll style={{ transform: "scale(3)" }} />}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BenefitCard
              title="Φορολογική Ασυλία"
              padding="18%"
              description="Περιορισμός σε 3 έτη, έναντι 5, του διαστήματος υποχρεωτικής τήρησης των στοιχείων που υπόκεινται σε φορολογικό έλεγχο."
              icon={<AssuredWorkload style={{ transform: "scale(3)" }} />}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BenefitCard
              title="Επιστροφές Φόρων"
              padding="18%"
              description="Επιστροφή οποιουδήποτε οφειλόμενου φόρου εντός 45 ημερών έναντι του διαστήματος των 90 ημερών όπως γενικά ισχύει."
              icon={<CurrencyExchange style={{ transform: "scale(3)" }} />}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BenefitCard
              title="Αποστολή στο Δικαιούχο"
              padding="25%"
              description="Το παραστατικό αποστέλλεται στον δικαιούχο, με ταυτόχρονη ενημέρωσή του μέσω e-mail ή SMS. Δηλαδή δεν είναι απαραίτητη η εκτύπωση του παραστατικού, αν αυτό είναι επιθυμητό."
              icon={<ContentPasteGo style={{ transform: "scale(3)" }} />}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <BenefitCard
              title="Αρχειοθέτηση & Διαφύλαξη"
              padding="25%"
              description="Τα παραστατικά αρχειοθετούνται και διαφυλάσσονται, για το χρονικό διάστημα που προβλέπει η σχετική νομοθεσία ή και για περισσότερο κατόπιν συμφωνίας. Εύκολη πρόσβαση, αποθήκευση, έλεγχο ή αναζήτηση όλων των εκδοθέντων παραστατικών"
              icon={<Topic style={{ transform: "scale(3)" }} />}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <BenefitCard
              title="Άμεση Απόσβεση Επένδυσης"
              padding="25%"
              description="Απόσβεση, κατά το πρώτο έτος, του κόστους εξοπλισμού & λογισμικού που η προμήθειά του απαιτήθηκε για τη λήψη υπηρεσιών Παρόχου."
              icon={<BarChart style={{ transform: "scale(3)" }} />}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BenefitCard
              title="Αποστολή στο myDATA"
              padding="15%"
              description="Το παραστατικό αποστέλλεται άμεσα στην Πλατφόρμα myDATA με ταυτόχρονη επιβεβαίωσης της ορθότητάς του."
              icon={<CloudSync style={{ transform: "scale(3)" }} />}
            />
          </Grid>
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default Faq;
